import React from 'react';

import { useQuery } from '@apollo/react-hooks';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { CONTACT_US_DEPARTMENTS } from '../../graphql/contact';
import { ListContactUsDepartmentsData } from '../../types';
import { ContactForm } from './ContactForm';
import useStyles from './styles';

const ContactFormBlock = ({ data: blockData }) => {
  const background = blockData?.background;
  const heading = blockData?.heading;
  const classes = useStyles(background)();
  const { t } = useTranslation();

  const { data: departmentsData, loading } = useQuery<ListContactUsDepartmentsData>(
    CONTACT_US_DEPARTMENTS,
  );

  if (loading) {
    return <div>{t('common.loading')}...</div>;
  }

  const departments = departmentsData?.listContactUsDepartments || [];

  return (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'contact-form-block',
      )}
    >
      <Container className={classes.container}>
        <Typography variant="h2" component="h2" align="center" className={classes.desktopHeading}>
          {heading}
        </Typography>

        <div className={classes.content}>
          <ContactForm background={background} departments={departments} />
          <Typography variant="h2" component="h2" align="center" className={classes.heading}>
            {heading}
          </Typography>
          {/* eslint-disable-next-line */}
          <a
            className={classes.contactMap}
            href="https://goo.gl/maps/SUchyy1iTAdrrX196"
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      </Container>
    </Box>
  );
};

export default ContactFormBlock;
